import { Alert, Col, Flex, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import TaskItem from '@/components/candidates/kanban/Task';
import { COMPLETED } from '@/constants/statuses';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { getRandomColor } from '@/theme/avatarPalette';
import Avatar from '@/UI/Avatar/Avatar';
import { orderTasks } from '@/utils/candidate';

import type { InterviewRoom, InterviewTask } from '@/types/interview';

interface StageFormProps {
  interview: InterviewRoom;
  handleComplete: (id: string) => void;
}

const InterviewStageModalForm = ({
  interview,
  handleComplete,
}: StageFormProps) => {
  const [t] = useTranslation();
  const { isGuest: isDecisionMaker } = useCurrentUser();
  const sortedTasks: InterviewTask[] = [
    ...(interview.current_stage?.tasks ?? []),
  ].sort((a, b) => (a.id < b.id ? -1 : 1));
  const isUncompleted = interview?.current_stage?.tasks?.filter(
    (el) => el.status !== COMPLETED,
  ).length;

  return (
    <>
      <Row>
        <Col xs={24} md={12}>
          <Flex align="center">
            <Avatar
              name={interview.job.company.name}
              src={
                interview.job.company.image
                  ? interview.job.company.image
                  : import.meta.env.BASE_URL + 'images/company-logo.png'
              }
              color={getRandomColor()}
              title={interview.job.company.name}
            />
            <Typography.Text type="secondary">&</Typography.Text>
            <Avatar
              name={interview.candidate?.name}
              color={getRandomColor()}
              title={interview.candidate?.name}
            />
          </Flex>
        </Col>
        <Col xs={24} md={12}>
          <Typography.Title level={3} style={{ textAlign: 'right' }}>
            {interview.job.title}
          </Typography.Title>
        </Col>
      </Row>

      <Typography.Title level={4} type="secondary">
        {t('DESCRIPTION')}
      </Typography.Title>
      <Typography.Text>
        {interview.current_stage?.description ?? ''}
      </Typography.Text>

      {isDecisionMaker && !isUncompleted ? (
        <Alert type="error" showIcon={false} title={t('NOT_ACTUAL')} />
      ) : (
        <>
          <Typography.Title level={4} type="secondary">
            {t('TASKS')}
          </Typography.Title>
          {orderTasks(sortedTasks).map((task) => (
            <TaskItem
              interview={interview}
              data={task}
              key={task.id}
              name={interview.client.name}
              handleComplete={handleComplete}
            />
          ))}
        </>
      )}
    </>
  );
};

export default InterviewStageModalForm;
